"use client";

import type { FC, PropsWithChildren } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { ProvincePopup as ProvincePopupUI } from "@jti/ui/components/ProvincePopup";

import { useDisplayModelComponent } from "@/libs/builder/hooks/useDisplayModelComponent";

import type { provincePopupInputs } from "./ProvincePopup.builder";

export type ProvincePopupProps = BuilderComponentProps<typeof provincePopupInputs>;

export const ProvincePopup: FC<PropsWithChildren<ProvincePopupProps>> = ({
  logo,
  paragraph,
  image,
  primaryButton,
  secondaryButton,
  backgroundColor,
  isParagraphEnabled,
  isImageEnabled,
  isLogoEnabled,
}) => {
  const shouldDisplayModelComponent = useDisplayModelComponent("province-popup");
  if (!shouldDisplayModelComponent) {
    return null;
  }
  return (
    <ProvincePopupUI
      paragraph={paragraph}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      logo={logo}
      image={image}
      backgroundColor={backgroundColor}
      isLogoEnabled={isLogoEnabled}
      isParagraphEnabled={isParagraphEnabled}
      isImageEnabled={isImageEnabled}
      isAuthorMode={isEditing()}
    />
  );
};
